import React, { useEffect, useState, useMemo, Fragment } from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'
import Dropzone from 'react-dropzone'
import Chip from '@material-ui/core/Chip'
import AttachFileIcon from '@material-ui/icons/AttachFile'
import { getBase64 } from 'Containers/StatsDeliverability/UploadFile/utils'
import { Button, Grid, Modal, OutlinedInput } from '@material-ui/core'
import { styles } from './styles'
import RichTextEditor from '../../../../../../../Components/RichTextEditor'
import EmojiPicker from '../../../../../../../Components/EmojiPicker'
import SubmitButton from '../../../../../../../Components/Form/Button'
import Form from '../../../../../../../Components/Form'
import { EMAIL_TYPE } from '../../options'
import useGraphQLFetch from '../../../../../../../Utils/Hooks/useGraphQLFetch'
import { getClientRecipientsEmailData } from '../../graphQL'
import LoadingIndicator from '../../../../../../../Components/LoadingIndicator/LoadingIndicator'
import { CAMPAIGN_ENUM_TYPES } from '../../../../../../../shared/constants'
import { UploadFileIcon } from '../../../../../../../Assets/Images/icons/uploadFile'

const emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
const MAX_FILE_SIZE = 10485760 // 10MB

const EmailModal = ({
  classes,
  open,
  controlModal,
  user,
  onSubmit,
  emailId,
  data,
  isLoadingRequest = true,
}) => {
  if (!data) {
    return null
  }

  const { email: userEmail, firstName, lastName } = user
  const userName = `${firstName} ${lastName}`
  const {
    clientName,
    emailType,
    campaignId,
    campaignName,
    paymentIntent,
    isPaymentSkipped,
    clientId,
    dynamicCouponCode,
    staticCouponCode,
    type,
    subtype,
  } = data

  const [file, setFile] = useState(null)
  const [fileError, setFileError] = useState('')
  const isDm = type === CAMPAIGN_ENUM_TYPES.DIRECTMAIL

  const {
    data: clientRecipientsEmailData,
    isLoaded,
    isLoading,
  } = useGraphQLFetch({
    fetchFn: getClientRecipientsEmailData,
    defaultFetchArgs: clientId,
    mapResponse: data => data.clientRecipientsEmailData,
    fetchId: 'getClientRecipientsEmailData',
  })

  const initialEmailData = {
    sender: { value: userEmail },
    bcc: { value: '' },
    subject: { value: `Re: ${campaignName}`, error: false },
  }

  const handleFileDrop = async (files, rejectedFiles) => {
    if (rejectedFiles.length) {
      const rejectedFile = rejectedFiles[0]
      if (rejectedFile.size > MAX_FILE_SIZE) {
        setFileError('The file should not exceed 10mb')
      } else {
        setFileError('Error while attaching the file')
      }
      return
    } else if (files.length) {
      setFileError(null)
      const newFile = files[0]
      const fileName = newFile.name
      const mimeType = newFile.type

      let fileBase64 = await getBase64(newFile)
      fileBase64 = fileBase64.split(',')[1]
      setFile({ name: fileName, base64: fileBase64, type: mimeType })
    }
  }

  const initialInputsData = useMemo(() => {
    if (emailType === EMAIL_TYPE.APPROVE_CAMPAIGN) {
      return {
        ...initialEmailData,
        subject: {
          value: `${campaignName} - Campaign Approved`,
          error: false,
        },
        body: {
          value: [
            {
              type: 'paragraph',
              align: 'left',
              children: [{ text: `Hi ${clientName},` }],
            },
            {
              type: 'paragraph',
              align: 'left',
              children: [{ text: '' }],
            },
            {
              type: 'paragraph',
              align: 'left',
              children: [
                {
                  text: `We are pleased to inform you that ${campaignName}, has been approved.`,
                },
              ],
            },

            {
              type: 'paragraph',
              align: 'left',
              children: [{ text: '' }],
            },
            {
              type: 'paragraph',
              align: 'left',
              children: [
                {
                  text: `Our team will review the campaign and notify you of any further instructions or feedback as soon as possible. Please let us know if you have any questions or concerns.`,
                },
              ],
            },
            {
              type: 'paragraph',
              align: 'left',
              children: [{ text: '' }],
            },
            {
              type: 'paragraph',
              align: 'left',
              children: [
                {
                  text: `We value your feedback and are here to assist you in any way we can.`,
                },
              ],
            },
            {
              type: 'paragraph',
              align: 'left',
              children: [{ text: '' }],
            },
            {
              type: 'paragraph',
              align: 'left',
              children: [{ text: '' }],
            },
            {
              type: 'paragraph',
              align: 'left',
              children: [{ text: 'Best regards,' }],
            },
            {
              type: 'paragraph',
              align: 'left',
              children: [{ text: `Promofy` }],
            },
          ],
          error: false,
        },
      }
    } else if (emailType === EMAIL_TYPE.DECLINE_CAMPAIGN) {
      return {
        ...initialEmailData,
        subject: {
          value: `${campaignName} - Campaign Declined`,
          error: false,
        },
        body: {
          value: [
            {
              type: 'paragraph',
              align: 'left',
              children: [{ text: `Hi ${clientName},` }],
            },
            {
              type: 'paragraph',
              align: 'left',
              children: [{ text: '' }],
            },
            {
              type: 'paragraph',
              align: 'left',
              children: [
                {
                  text: `Unfortunately, we are unable to approve campaign ${campaignName}, Please review the following issues to be fixed in order to get approved:`,
                },
              ],
            },
            {
              type: 'paragraph',
              align: 'left',
              children: [{ text: '' }],
            },
            {
              align: 'left',
              children: [
                {
                  align: 'left',
                  children: [{ text: 'Reason 1' }],
                  type: 'list-item',
                },
                {
                  type: 'paragraph',
                  align: 'left',
                  children: [{ text: '' }],
                },
                {
                  align: 'left',
                  children: [{ text: 'Reason 2' }],
                  type: 'list-item',
                },
                {
                  type: 'paragraph',
                  align: 'left',
                  children: [{ text: '' }],
                },
                {
                  align: 'left',
                  children: [{ text: 'Reason 3' }],
                  type: 'list-item',
                },
              ],
              type: 'bulleted-list',
            },
            {
              type: 'paragraph',
              align: 'left',
              children: [{ text: '' }],
            },
            {
              type: 'paragraph',
              align: 'left',
              children: [
                {
                  text: `Once these points have been addressed, please re-submit the campaign for review. If you need further assistance don't hesitate to reach out by replying to this email.`,
                },
              ],
            },
            {
              type: 'paragraph',
              align: 'left',
              children: [{ text: '' }],
            },
            {
              type: 'paragraph',
              align: 'left',
              children: [{ text: 'Best regards,' }],
            },
            {
              type: 'paragraph',
              align: 'left',
              children: [{ text: `${userName}` }],
            },
          ],
          error: false,
        },
      }
    } else {
      return {
        ...initialEmailData,
        body: {
          value: [
            {
              type: 'paragraph',
              align: 'left',
              children: [{ text: `Hi ${clientName},` }],
            },
            {
              type: 'paragraph',
              align: 'left',
              children: [{ text: '' }],
            },
            {
              type: 'paragraph',
              align: 'left',
              children: [{ text: '/** Enter your message here **/' }],
            },
            {
              type: 'paragraph',
              align: 'left',
              children: [{ text: '' }],
            },
            {
              type: 'paragraph',
              align: 'left',
              children: [{ text: 'Best,' }],
            },
            {
              type: 'paragraph',
              align: 'left',
              children: [{ text: `${userName}` }],
            },
          ],
          error: false,
        },
      }
    }
  }, [emailType, isLoaded, initialEmailData])

  const [insertedValue, setInsertedValue] = useState(null)
  const [disabled, setDisabled] = useState(true)
  const [emojiPicked, setEmojiPicked] = useState(null)
  const [inputsData, setInputsData] = useState(initialInputsData)
  const [lastClicked, setLastClicked] = useState({
    component: null,
    position: 0,
  })

  useEffect(() => {
    if (isLoaded) {
      setInputsData(prev => ({
        ...prev,
        recipients: {
          value: clientRecipientsEmailData.recipients.join(', '),
          error: !clientRecipientsEmailData.recipients.join(', ').length,
        },
        cc: { value: clientRecipientsEmailData.cc.join(', ') },
      }))
    }
  }, [isLoaded])

  useEffect(() => {
    setDisabled(
      Object.values(inputsData)
        .map(item => item.error)
        .some(item => item),
    )
  }, [inputsData, isLoaded])

  const handleSubjectInsert = value => {
    const input = document.getElementById('subjectInput')

    let pos = lastClicked.position
    const front = input.value.substring(0, pos)
    const back = input.value.substring(pos, input.value.length)
    const newValue = front + value + back
    const event = {
      target: {
        value: newValue,
      },
    }
    handleChange({ type: 'subject', event })
    setLastClicked(prev => ({ ...prev, position: pos + value.length }))
  }

  const getClickedPosition = component => {
    if (component === 'subject') {
      return document.getElementById('subjectInput').selectionStart
    }
  }

  const handleEmojiClick = (event, emojiObject) => {
    setEmojiPicked(emojiObject.emoji)
  }

  useEffect(() => {
    if (!emojiPicked) return
    if (lastClicked.component === 'body') {
      setInsertedValue(emojiPicked)
    } else if (lastClicked.component === 'subject') {
      handleSubjectInsert(emojiPicked)
    }
    setEmojiPicked(null)
  }, [emojiPicked])

  const handleSubmit = async ({ sendEmail }) => {
    const newInputValues = Object.keys(inputsData).reduce((acc, key) => {
      acc[key] = {
        value: inputsData[key].value,
        error:
          key === 'cc' || key === 'bcc' ? false : !inputsData[key].value.length,
      }
      return acc
    }, {})

    const disabled =
      sendEmail &&
      !!fileError &&
      Object.values(newInputValues)
        .map(item => item.error)
        .some(item => item)

    if (disabled) {
      setInputsData(newInputValues)
    } else {
      const emailData = {
        ...inputsData,
        attachments: file
          ? [
              {
                content: file.base64,
                filename: file.name,
                encoding: 'base64',
              },
            ]
          : [],
      }

      onSubmit({
        data: emailData,
        sendEmail,
        emailType,
        campaignId,
        paymentIntent,
        isPaymentSkipped,
        clientId,
        isMoveInGenerationDigitalProof: !!(
          dynamicCouponCode ||
          staticCouponCode ||
          isDm
        ),
        type,
        subtype,
      })
    }
  }

  const handleChange = ({ type, event }) => {
    const isCCBCC = type === 'cc' || type === 'bcc'
    if (isCCBCC) {
      const newValue = event.target.value
      let error = false
      if (newValue.length > 0) {
        error = newValue
          .split(',')
          .map(email => email.trim())
          .some(email => !emailRegex.test(email))
      }
      const newInputValues = {
        ...inputsData,
        [type]: { value: newValue, error },
      }
      setInputsData(newInputValues)
    } else {
      setInputsData({
        ...inputsData,
        [type]: { value: event.target.value, error: !event.target.value },
      })
    }
  }

  const handleBodyChange = value => {
    setInputsData({
      ...inputsData,
      body: { value, error: !value },
    })
  }

  const errorComponent = error => {
    return error ? <div style={styles.error}>field is required</div> : null
  }

  return (
    <Form>
      <Modal
        open={open}
        onClose={() => controlModal({ open: false, id: null })}
        disablePortal={true}
      >
        <div className={classes.body}>
          {isLoading || isLoadingRequest ? (
            <LoadingIndicator />
          ) : (
            <Fragment>
              <span className={classNames(classes.boldText)}>
                {emailType === EMAIL_TYPE.DECLINE_CAMPAIGN
                  ? 'Decline campaign email'
                  : emailType === EMAIL_TYPE.APPROVE_CAMPAIGN
                  ? 'Approve campaign email'
                  : 'Create new email'}
              </span>
              <div>
                <div
                  className={classNames(
                    classes.rowContainer,
                    classes.wrapperSelect,
                  )}
                />
              </div>
              <div className={classes.wrapperSelect}>
                <span className={classes.smallText}>Send email from:</span>
                <span className={classes.sender}>{userEmail}</span>
              </div>
              <Grid
                container
                xs={12}
                direction="column"
                className={classes.inputContainer}
              >
                <Grid className={classes.rowContainer}>
                  <span className={classes.recipients}>Recipient:</span>
                  <OutlinedInput
                    value={
                      inputsData.recipients ? inputsData.recipients.value : ''
                    }
                    onChange={event =>
                      handleChange({ type: 'recipients', event })
                    }
                    style={styles.input}
                  />
                </Grid>
                <Grid className={classes.rowContainer}>
                  <span className={classes.ccText}>CC:</span>
                  <OutlinedInput
                    placeholder="Separate recipients with a “,” and leave empty if N/A"
                    value={inputsData.cc ? inputsData.cc.value : ''}
                    onChange={event => handleChange({ type: 'cc', event })}
                    style={styles.input}
                  />
                </Grid>
                <Grid className={classes.rowContainer}>
                  <span className={classes.bccText}>BCC:</span>
                  <OutlinedInput
                    placeholder="Separate recipients with a “,” and leave empty if N/A"
                    value={inputsData.bcc.value}
                    onChange={event => handleChange({ type: 'bcc', event })}
                    style={styles.input}
                  />
                </Grid>
                <Grid className={classes.rowContainer}>
                  <span className={classes.sbjtText}>Subject:</span>
                  <OutlinedInput
                    id={'subjectInput'}
                    value={inputsData.subject.value}
                    onChange={event => handleChange({ type: 'subject', event })}
                    style={styles.input}
                    error={inputsData.subject.error}
                    onClick={() =>
                      setLastClicked({
                        component: 'subject',
                        position: getClickedPosition('subject'),
                      })
                    }
                  />
                </Grid>
                {errorComponent(inputsData.subject.error)}
              </Grid>
              <Grid item className={classes.dropzoneContainer}>
                {file ? (
                  <Chip
                    icon={<AttachFileIcon />}
                    label={file.name}
                    clickable
                    onDelete={() => setFile(null)}
                    variant="outlined"
                  />
                ) : (
                  <Fragment>
                    <span className={classes.sbjtText}>Attachment:</span>
                    <Dropzone
                      accept={''}
                      activeClassName={classes.dropzoneActive}
                      className={classes.dropzone}
                      multiple={false}
                      onDrop={handleFileDrop}
                      disabled={false}
                      maxSize={MAX_FILE_SIZE}
                    >
                      <div className={classes.dropzoneContent}>
                        <UploadFileIcon className={classes.uploadIcon} />
                        <span>Drop your file here</span>
                        <span>File max size: 10mb</span>
                        {!!fileError && (
                          <span style={{ color: 'red' }}>{fileError}</span>
                        )}
                      </div>
                    </Dropzone>
                  </Fragment>
                )}
              </Grid>
              <Grid container xs={12} className={classes.rowContainer}>
                <RichTextEditor
                  key={`email-${emailId}`}
                  index={`email-${emailId}`}
                  markTools
                  listTools
                  extraTools={<EmojiPicker onEmojiClick={handleEmojiClick} />}
                  fontSize="12px"
                  rows="20"
                  textToInsert={insertedValue}
                  onChange={handleBodyChange}
                  value={inputsData.body.value}
                  onClick={() =>
                    setLastClicked({ component: 'body', position: null })
                  }
                />
              </Grid>
              {errorComponent(inputsData.body.error)}
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ paddingTop: '10px' }}
                xs={12}
              >
                <Grid container xs justifyContent="flex-end">
                  <Button
                    variant="text"
                    onClick={() => controlModal({ open: false, id: null })}
                    style={{ marginRight: '16px' }}
                    className={classes.button}
                  >
                    Cancel
                  </Button>

                  {emailType === EMAIL_TYPE.DECLINE_CAMPAIGN ||
                  emailType === EMAIL_TYPE.APPROVE_CAMPAIGN ? (
                    <SubmitButton
                      className={classes.submitButton}
                      onClick={() => handleSubmit({ sendEmail: false })}
                      style={{ marginRight: '16px' }}
                    >
                      {emailType === EMAIL_TYPE.DECLINE_CAMPAIGN
                        ? 'Decline without sending email'
                        : 'Approve without sending email'}
                    </SubmitButton>
                  ) : null}
                  <SubmitButton
                    className={classes.submitButton}
                    onClick={() => handleSubmit({ sendEmail: true })}
                    disabled={disabled}
                  >
                    {emailType === EMAIL_TYPE.DECLINE_CAMPAIGN
                      ? 'Decline'
                      : emailType === EMAIL_TYPE.APPROVE_CAMPAIGN
                      ? 'Approve'
                      : 'Send'}
                  </SubmitButton>
                </Grid>
              </Grid>
            </Fragment>
          )}
        </div>
      </Modal>
    </Form>
  )
}

export default injectStyles(styles)(EmailModal)
